<template>
    <div class="sc-user-input">
        <form class="sc-user-input--form" @submit.prevent="submit">
            <input type="file" id="files-chat" ref="files" name="files[]" multiple />
            <div class="sc-user-inputs">
                <div :class="['sc-user-input--textarea', {'textarea': messageToEdit}]">
                    <template v-if="locale === 'de'">
                        <span>Schreiben Sie eine Nachricht</span>
                    </template>
                    <template v-else>
                        <span>{{ __('Start typing or') }}&nbsp;</span>
                        <a href="#" data-target="#modal-chat-templates" data-toggle="modal" data-origin="window">
                            {{ __('select from template') }}
                        </a>
                    </template>
                    <textarea
                        ref="userInput"
                        v-model="message"
                        id="message"
                        tabIndex="0"
                        class="sc-user-input--text"
                        :placeholder="__('Type your message')"
                        autofocus
                    ></textarea>
                </div>
                <div class="sc-user-input--buttons">
                    <div class="sc-user-input--button">
                        <a href="#" data-target="#modal-chat-templates" data-toggle="modal" data-origin="window">
                            <span class="sc-user-input--tooltip">{{ __('Select from template') }}</span>
                            <!-- TODO extract svg -->
                            <svg
                                aria-hidden="true"
                                focusable="false"
                                data-prefix="fas"
                                data-icon="align-left"
                                width="24"
                                height="24"
                                class="svg-inline--fa fa-align-left fa-w-14"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 448 512"
                            >
                                <path
                                    fill="#b1b1b1"
                                    d="M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                                ></path>
                            </svg>
                        </a>
                    </div>
                    <div class="sc-user-input--button emoji-button">
                        <EmojiIcon :onEmojiPicked="onEmojiPicked" />
                    </div>
                    <div class="sc-user-input--button file-button">
                        <div class="sc-user-input--picker-wrapper">
                            <button type="button" @click.prevent="uploadFile()">
                                <span class="sc-user-input--tooltip">{{ __('Upload image/document') }}</span>
                                <svg
                                    width="22"
                                    height="25"
                                    viewBox="0 0 22 25"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M2.1875 21.9375C3.03125 22.875 4.0625 23.4844 5.28125 23.7656C6.5 24.0938 7.67188 24.0938 8.89062 23.7656C10.0625 23.4844 11.0938 22.875 12.0312 21.9375L21.1719 12.75C21.2656 12.6562 21.3594 12.5625 21.3594 12.375C21.3594 12.2344 21.2656 12.0938 21.1719 11.9531L20.375 11.1562C20.2812 11.0625 20.1406 11.0156 20 11.0156C19.8125 11.0156 19.6719 11.0625 19.5781 11.1562L10.4375 20.3438C9.5 21.2812 8.375 21.75 7.0625 21.75C5.75 21.75 4.67188 21.3281 3.73438 20.3906C2.79688 19.4531 2.375 18.375 2.375 17.0625C2.375 15.75 2.79688 14.625 3.73438 13.6875L14.2812 3.14062C14.8906 2.57812 15.6406 2.25 16.4844 2.25C17.3281 2.25 18.0781 2.57812 18.6875 3.1875C19.2969 3.79688 19.625 4.54688 19.625 5.39062C19.625 6.23438 19.2969 6.98438 18.7344 7.54688L9.82812 16.4531C9.54688 16.7344 9.17188 16.875 8.75 16.875C8.32812 16.875 7.95312 16.7344 7.67188 16.4531C7.34375 16.1719 7.20312 15.7969 7.20312 15.375C7.20312 14.9531 7.34375 14.5781 7.67188 14.2969L15.1719 6.75C15.2656 6.65625 15.3594 6.5625 15.3594 6.375C15.3594 6.23438 15.2656 6.09375 15.1719 5.95312L14.375 5.15625C14.2812 5.0625 14.1406 5.01562 14 5.01562C13.8125 5.01562 13.7188 5.0625 13.625 5.15625L6.07812 12.7031C5.32812 13.4531 4.95312 14.3438 4.95312 15.375C4.95312 16.4062 5.32812 17.2969 6.07812 18.0469C6.82812 18.7969 7.71875 19.125 8.75 19.125C9.78125 19.125 10.6719 18.7969 11.4219 18.0469L20.2812 9.14062C20.9375 8.48438 21.4062 7.6875 21.6875 6.75C21.9219 5.8125 21.9219 4.92188 21.6875 3.98438C21.4062 3.04688 20.9375 2.25 20.2812 1.59375C19.5781 0.9375 18.7812 0.46875 17.8438 0.1875C16.9062 -0.046875 16.0156 -0.046875 15.0781 0.1875C14.1406 0.46875 13.3906 0.890625 12.7344 1.54688L2.1875 12.1406C1.25 13.0312 0.640625 14.0625 0.359375 15.2344C0.03125 16.4531 0.03125 17.625 0.359375 18.8438C0.640625 20.0625 1.25 21.0938 2.1875 21.9375Z"
                                        fill="#B3B1C2"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div class="sc-user-input--button">
                        <button
                            type="submit"
                            :class="[
                                'sc-user-input--send-icon-wrapper',
                                {
                                    disabled:
                                        (message === '' && files.length === 0) ||
                                        loading ||
                                        totalFilesSize(files) > 10000000
                                }
                            ]"
                        >

                            <span v-if="messageToEdit">{{ __('Save changes') }}</span>
                            <span v-else>{{ __('Send') }}</span>
                            <!-- TODO extract svg -->
                            <div v-if="loading" class="loader loader--chat loader--grey-background">
                                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner" class="svg-inline--fa fa-spinner fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path></svg>
                            </div>
                            <svg
                                v-else
                                width="42"
                                height="42"
                                viewBox="0 0 35 36"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                                <title>Group 2</title>
                                <desc>Created with Sketch.</desc>
                                <g id="Lympha-stage" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="Vitadio_soukromé-zprávy" transform="translate(-1349.000000, -834.000000)">
                                        <g id="Group-2" transform="translate(1349.000000, 834.000000)">
                                            <g id="send" transform="translate(9.000000, 10.000000)" fill="#5937B7">
                                                <path
                                                    d="M18.808889,6.74023189 L2.67240008,0.14676662 C1.9925952,-0.131035178 1.22458717,-0.0088285438 0.668141704,0.465534759 C0.111696234,0.939974994 -0.121038206,1.67098377 0.0608368451,2.37325841 L1.49712631,7.91975479 L8.52939392,7.91975479 C8.85298776,7.91975479 9.11537065,8.17809277 9.11537065,8.49678397 C9.11537065,8.81543671 8.85302682,9.07381316 8.52939392,9.07381316 L1.49712631,9.07381316 L0.0608368451,14.6202711 C-0.121038206,15.3225842 0.111657172,16.053593 0.668141704,16.5279947 C1.22571999,17.0033197 1.99380614,17.1240261 2.67243914,16.8467629 L18.8089281,10.2533361 C19.5436158,9.95314701 19.9999831,9.28006811 19.9999831,8.49678397 C19.9999831,7.71349984 19.5436158,7.04038247 18.808889,6.74023189 Z"
                                                    id="Path"
                                                ></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </div>
                </div>

                <div class="sc-user-input--window">
                    <button
                        data-target="#modal-chat-message"
                        data-toggle="modal"
                        data-dismiss="modal"
                        type="button"
                        @click="openChatWidget(message)"
                    >
                        <span class="sc-user-input--tooltip">{{ __('Open chat window') }}</span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import EmojiIcon from './emoji/EmojiIcon.vue'

    export default {
        components: {
            EmojiIcon
        },
        props: {
            send: {
                type: Boolean,
                required: true
            },
            messageToEdit: {
                type: Object,
                required: false
            },
            conversation: {
                type: Object,
                required: false
            }
        },
        data() {
            return {
                message: '',
                files: [],
                loading: false,
                cursorPosition: null
            }
        },
        watch: {
            async 'message'(message) {
                const textarea = $('.sc-user-input--text')[0]

                this.cursorPosition = textarea.selectionStart

                await this.$nextTick()

                if (message === '') {
                    textarea.style.height = '32px'
                } else {
                    textarea.style.height = textarea.scrollHeight + 'px'
                }

                this.changeListHeight()
            },
            send(send) {
                if (send == true) {
                    $('#files-chat').fileinput('destroy')

                    this.message = ''
                    this.$refs.userInput.style.height = ''
                    this.files = []

                    this.loading = false
                    this.changeListHeight()
                }
            },
            async messageToEdit(message) {
                const textarea = $('.sc-user-input--text')[0]

                this.cursorPosition = textarea.selectionStart

                await this.$nextTick()

                this.message = message.body

                if (message === '') {
                    textarea.style.height = '32px'
                } else {
                    textarea.style.height = textarea.scrollHeight + 'px'
                }

                if(message.files) {
                    const fileInput = $('#files-chat')

                    this.createFileInput(fileInput)
                }

                this.changeListHeight()
            }
        },
        mounted() {
            var that = this
            Vuemit.listen('Chat--send-message', this.onSendMessage)
            Vuemit.listen('Chat--input-add-message', this.onAddInputMessage)

            $('.sc-user-input--textarea span').click(function () {
                $('.sc-user-input--textarea').addClass('textarea')
                $('.sc-user-input--textarea textarea').focus()
            })

            const textarea = $('.sc-user-input--text')

            textarea.on('click', function() {
                that.cursorPosition = textarea[0].selectionStart
            })

            textarea.on('keyup', function() {
                that.cursorPosition = textarea[0].selectionStart
            })
        },
        beforeDestroy() {
            Vuemit.remove('Chat--send-message', this.onSendMessage)
            Vuemit.remove('Chat--input-add-message', this.onAddInputMessage)
        },
        methods: {
            ...mapActions({
                sendMessage: 'chat/sendMessage',
                openChatWidget: 'chat/openChatWidget',
                updateMessage: 'chat/updateMessage'
            }),
            onEmojiPicked(emoji) {
                var textBefore = this.message.substring(0, this.cursorPosition);
                var textAfter  = this.message.substring(this.cursorPosition, this.message.length);

                this.message = textBefore + emoji + textAfter

            },
            handleKey(event) {
                var isDisabled = $('.sc-user-input--send-icon-wrapper').hasClass('disabled')

                // submit if enter was pressed without shift
                if (event.keyCode === 13 && !event.shiftKey) {
                    if (!isDisabled) {
                        this.submit()
                    }

                    event.preventDefault()
                }
            },
            onSendMessage(message) {
                this.message = message
                this.submit()
            },
            onAddInputMessage({ origin, template }) {
                if (origin !== 'window') return

                if (!$('.sc-user-input--textarea').hasClass('textarea')) {
                    $('.sc-user-input--textarea span').click()
                }

                if (this.message && !this.message.endsWith(' ')) {
                    this.message += ' '
                }

                this.message += template.body
            },
            async submit() {
                if (!this.message && this.files.length < 1) {
                    return false
                }

                this.loading = true

                if(this.messageToEdit) {
                    await this.updateMessage({
                        body: this.message,
                        files: this.files,
                        uuid: this.messageToEdit.uuid
                    })
                } else {
                    await this.sendMessage({
                        body: this.message,
                        files: this.files
                    })
                }
            },
            createFileInput(fileInput) {
                var that = this
                fileInput.fileinput('destroy')

                var urls = []
                var files = []

                if(this.messageToEdit && this.messageToEdit.files.length > 0) {
                    this.messageToEdit.files.forEach(element => {
                        urls.push(element.path)

                        files.push(
                            {
                                caption: element.filename,
                                type: element.type === 'IMAGE' ? 'image' : element.type,
                                downloadUrl: element.path,
                                size: element.size,
                                url: `/api/chat/message/${this.messageToEdit.uuid}/file/delete`,
                                extra: { path: element.relative_path, channel_id: this.conversation.channel_id }
                            }
                        )
                    });
                }

                fileInput
                    .fileinput({
                        initialPreview: urls,
                        initialPreviewAsData: true,
                        initialPreviewConfig: files,
                        overwriteInitial: false,
                        showZoom: false,
                        showUpload: false,
                        showCancel: false,
                        showRemove: false,
                        showCaption: false,
                        dropZoneEnabled: false,
                        retryErrorUploads: false,
                        removeFromPreviewOnError: true,
                        showUploadedThumbs: true,
                        uploadUrl: '/',
                        allowedPreviewTypes: ['image'],
                        allowedFileExtensions: ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx'],
                        language: _.get(window, 'locale', 'cs'),
                        maxFileSize: 10000,
                        layoutTemplates: {
                            main1:
                                '<span class="file-title">' +
                                lang.get('Attach file') +
                                '</span>\n{preview}\n' +
                                '<div class="kv-upload-progress kv-hidden"></div><div class="clearfix"></div>\n' +
                                '<div class="input-group {class}">\n' +
                                '  {caption}\n' +
                                '</div>',
                            main2:
                                '<span class="file-title">' +
                                lang.get('Attach file') +
                                '</span>{preview}\n<div class="kv-upload-progress hide"></div>',
                            size: '<samp>{sizeText}</samp>',
                            actions:
                                '<div class="file-actions">\n' +
                                '    <div class="file-footer-buttons">\n' +
                                '        {delete}' +
                                '    </div>\n' +
                                '    <div class="clearfix"></div>\n' +
                                '</div>',
                            preview:
                                '<div class="file-preview {class}">\n' +
                                '    <div class="{dropClass}">\n' +
                                '    <div class="file-preview-thumbnails">\n' +
                                '    </div>\n' +
                                '    {browse}' +
                                '    <div class="clearfix"></div>' +
                                '    <div class="file-preview-status text-center text-success"></div>\n' +
                                '    <div class="kv-fileinput-error"></div>\n' +
                                '    </div>\n' +
                                '</div>',
                            btnBrowse:
                                '<div tabindex="500" class="{css}"{status}><svg width="28px" height="25px" viewBox="0 0 28 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="Android-APP-wireframes" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="4" transform="translate(-296.000000, -521.000000)" fill="#FFFFFF" fill-rule="nonzero"> <g id="Button/Primary/New-Photo" transform="translate(280.000000, 504.000000)"> <path d="M44,23.25 L44,39.3214286 C44,40.8002232 42.8242188,42 41.375,42 L18.625,42 C17.1757812,42 16,40.8002232 16,39.3214286 L16,23.25 C16,21.7712054 17.1757812,20.5714286 18.625,20.5714286 L23.4375,20.5714286 L24.1101563,18.7354911 C24.4929688,17.6919643 25.471875,17 26.565625,17 L33.4289063,17 C34.5226563,17 35.5015625,17.6919643 35.884375,18.7354911 L36.5625,20.5714286 L41.375,20.5714286 C42.8242188,20.5714286 44,21.7712054 44,23.25 Z M36.5625,31.2857143 C36.5625,27.5915179 33.6203125,24.5892857 30,24.5892857 C26.3796875,24.5892857 23.4375,27.5915179 23.4375,31.2857143 C23.4375,34.9799107 26.3796875,37.9821429 30,37.9821429 C33.6203125,37.9821429 36.5625,34.9799107 36.5625,31.2857143 Z M34.8125,31.2857143 C34.8125,33.9921875 32.6523438,36.1964286 30,36.1964286 C27.3476562,36.1964286 25.1875,33.9921875 25.1875,31.2857143 C25.1875,28.5792411 27.3476562,26.375 30,26.375 C32.6523438,26.375 34.8125,28.5792411 34.8125,31.2857143 Z" id="foto"></path> </g> </g> </g> </svg></div>'
                        },
                        previewFileIconSettings: {
                            pdf:
                                '<svg width="28px" height="36px" viewBox="0 0 28 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>FEBBB219-DE67-469C-8384-D2544C3723C4</title> <g id="Android-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="2020-05_diskuse-priloha" transform="translate(-30.000000, -286.000000)"><g id="file-extension" transform="translate(30.000000, 286.000000)"><path d="M1.77556129,0 L20.1318194,0 L27.9943097,7.83196129 L27.9943097,34.1879484 C27.9943097,35.1525032 27.2122065,35.9337935 26.2484645,35.9337935 L1.77556129,35.9337935 C0.811819355,35.9337935 0.029716129,35.1525032 0.029716129,34.1879484 L0.029716129,1.74584516 C0.029716129,0.781290323 0.811909677,0 1.77556129,0 Z" id="Path" fill="#E2574C" fill-rule="nonzero"></path> <text id="PDF" font-family="Nunito-Black, Nunito" font-size="10" font-weight="700" line-spacing="16" fill="#FFFFFF"><tspan x="3.86" y="21">PDF</tspan></text> <path d="M27.9691097,7.85634839 L21.8838968,7.85634839 C20.9201548,7.85634839 20.1380516,7.07424516 20.1380516,6.11050323 L20.1380516,0.0174322581 L27.9691097,7.85634839 Z" id="Path" fill="#B53629" fill-rule="nonzero"></path></g></g></g></svg>',
                            doc:
                                '<svg width="28" height="36" viewBox="0 0 28 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.77563 0H20.1319L27.9944 7.83196V34.188C27.9944 35.1525 27.2123 35.9338 26.2485 35.9338H1.77563C0.811888 35.9338 0.0297852 35.1525 0.0297852 34.188L0.0297852 1.74585C0.0297852 0.78129 0.811979 0 1.77563 0Z" fill="#3B98E7"/><path d="M4.25465 22C3.98132 22 3.77132 21.9267 3.62465 21.78C3.47798 21.6333 3.40465 21.4233 3.40465 21.15V15.8C3.40465 15.5267 3.47798 15.3167 3.62465 15.17C3.77132 15.0233 3.98132 14.95 4.25465 14.95H6.27465C7.05465 14.95 7.72465 15.0933 8.28465 15.38C8.85132 15.66 9.28465 16.0633 9.58465 16.59C9.88465 17.1167 10.0346 17.7433 10.0346 18.47C10.0346 19.2033 9.88465 19.8367 9.58465 20.37C9.29132 20.8967 8.86132 21.3 8.29465 21.58C7.73465 21.86 7.06132 22 6.27465 22H4.25465ZM6.14465 20.52C6.83132 20.52 7.34465 20.3533 7.68465 20.02C8.03132 19.68 8.20465 19.1633 8.20465 18.47C8.20465 17.7767 8.03132 17.2633 7.68465 16.93C7.34465 16.5967 6.83132 16.43 6.14465 16.43H5.24465V20.52H6.14465ZM14.489 22.09C13.769 22.09 13.1424 21.9433 12.609 21.65C12.0824 21.35 11.6757 20.93 11.389 20.39C11.1024 19.8433 10.959 19.2033 10.959 18.47C10.959 17.7367 11.1024 17.1 11.389 16.56C11.6757 16.0133 12.0824 15.5933 12.609 15.3C13.1424 15.0067 13.769 14.86 14.489 14.86C15.209 14.86 15.8324 15.0067 16.359 15.3C16.8924 15.5933 17.299 16.0133 17.579 16.56C17.8657 17.1 18.009 17.7367 18.009 18.47C18.009 19.2033 17.8657 19.8433 17.579 20.39C17.2924 20.93 16.8824 21.35 16.349 21.65C15.8224 21.9433 15.2024 22.09 14.489 22.09ZM14.489 20.68C15.0224 20.68 15.439 20.4933 15.739 20.12C16.039 19.74 16.189 19.19 16.189 18.47C16.189 17.75 16.0357 17.2033 15.729 16.83C15.429 16.4567 15.0157 16.27 14.489 16.27C13.9557 16.27 13.539 16.4567 13.239 16.83C12.939 17.1967 12.789 17.7433 12.789 18.47C12.789 19.1967 12.939 19.7467 13.239 20.12C13.539 20.4933 13.9557 20.68 14.489 20.68ZM22.438 22.09C21.7313 22.09 21.1113 21.9433 20.578 21.65C20.0513 21.3567 19.6413 20.9367 19.348 20.39C19.0613 19.8433 18.918 19.2033 18.918 18.47C18.918 17.7433 19.0613 17.1067 19.348 16.56C19.6413 16.0133 20.0513 15.5933 20.578 15.3C21.1113 15.0067 21.7313 14.86 22.438 14.86C23.2847 14.86 24.028 15.0833 24.668 15.53C24.7813 15.61 24.8613 15.6967 24.908 15.79C24.9613 15.8833 24.988 16.0033 24.988 16.15C24.988 16.3567 24.928 16.5333 24.808 16.68C24.6947 16.82 24.5547 16.89 24.388 16.89C24.288 16.89 24.198 16.8767 24.118 16.85C24.038 16.8167 23.9447 16.7667 23.838 16.7C23.6047 16.56 23.3847 16.46 23.178 16.4C22.9713 16.34 22.758 16.31 22.538 16.31C21.9447 16.31 21.5013 16.49 21.208 16.85C20.9213 17.2033 20.778 17.7433 20.778 18.47C20.778 19.2033 20.9213 19.75 21.208 20.11C21.5013 20.4633 21.9447 20.64 22.538 20.64C22.738 20.64 22.9313 20.61 23.118 20.55C23.3047 20.4833 23.5447 20.3833 23.838 20.25C23.978 20.1767 24.0813 20.1267 24.148 20.1C24.2147 20.0733 24.2947 20.06 24.388 20.06C24.5547 20.06 24.6947 20.1333 24.808 20.28C24.928 20.42 24.988 20.5933 24.988 20.8C24.988 20.94 24.9613 21.06 24.908 21.16C24.8613 21.2533 24.7813 21.34 24.668 21.42C24.028 21.8667 23.2847 22.09 22.438 22.09Z" fill="white"/><path d="M27.9691 7.85454H21.8839C20.9202 7.85454 20.1381 7.07244 20.1381 6.1087V0.015625L27.9691 7.85454Z" fill="#1E7AC8"/></svg>',
                            docx:
                                '<svg width="28" height="36" viewBox="0 0 28 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.77563 0H20.1319L27.9944 7.83196V34.188C27.9944 35.1525 27.2123 35.9338 26.2485 35.9338H1.77563C0.811888 35.9338 0.0297852 35.1525 0.0297852 34.188L0.0297852 1.74585C0.0297852 0.78129 0.811979 0 1.77563 0Z" fill="#3B98E7"/><path d="M4.25465 22C3.98132 22 3.77132 21.9267 3.62465 21.78C3.47798 21.6333 3.40465 21.4233 3.40465 21.15V15.8C3.40465 15.5267 3.47798 15.3167 3.62465 15.17C3.77132 15.0233 3.98132 14.95 4.25465 14.95H6.27465C7.05465 14.95 7.72465 15.0933 8.28465 15.38C8.85132 15.66 9.28465 16.0633 9.58465 16.59C9.88465 17.1167 10.0346 17.7433 10.0346 18.47C10.0346 19.2033 9.88465 19.8367 9.58465 20.37C9.29132 20.8967 8.86132 21.3 8.29465 21.58C7.73465 21.86 7.06132 22 6.27465 22H4.25465ZM6.14465 20.52C6.83132 20.52 7.34465 20.3533 7.68465 20.02C8.03132 19.68 8.20465 19.1633 8.20465 18.47C8.20465 17.7767 8.03132 17.2633 7.68465 16.93C7.34465 16.5967 6.83132 16.43 6.14465 16.43H5.24465V20.52H6.14465ZM14.489 22.09C13.769 22.09 13.1424 21.9433 12.609 21.65C12.0824 21.35 11.6757 20.93 11.389 20.39C11.1024 19.8433 10.959 19.2033 10.959 18.47C10.959 17.7367 11.1024 17.1 11.389 16.56C11.6757 16.0133 12.0824 15.5933 12.609 15.3C13.1424 15.0067 13.769 14.86 14.489 14.86C15.209 14.86 15.8324 15.0067 16.359 15.3C16.8924 15.5933 17.299 16.0133 17.579 16.56C17.8657 17.1 18.009 17.7367 18.009 18.47C18.009 19.2033 17.8657 19.8433 17.579 20.39C17.2924 20.93 16.8824 21.35 16.349 21.65C15.8224 21.9433 15.2024 22.09 14.489 22.09ZM14.489 20.68C15.0224 20.68 15.439 20.4933 15.739 20.12C16.039 19.74 16.189 19.19 16.189 18.47C16.189 17.75 16.0357 17.2033 15.729 16.83C15.429 16.4567 15.0157 16.27 14.489 16.27C13.9557 16.27 13.539 16.4567 13.239 16.83C12.939 17.1967 12.789 17.7433 12.789 18.47C12.789 19.1967 12.939 19.7467 13.239 20.12C13.539 20.4933 13.9557 20.68 14.489 20.68ZM22.438 22.09C21.7313 22.09 21.1113 21.9433 20.578 21.65C20.0513 21.3567 19.6413 20.9367 19.348 20.39C19.0613 19.8433 18.918 19.2033 18.918 18.47C18.918 17.7433 19.0613 17.1067 19.348 16.56C19.6413 16.0133 20.0513 15.5933 20.578 15.3C21.1113 15.0067 21.7313 14.86 22.438 14.86C23.2847 14.86 24.028 15.0833 24.668 15.53C24.7813 15.61 24.8613 15.6967 24.908 15.79C24.9613 15.8833 24.988 16.0033 24.988 16.15C24.988 16.3567 24.928 16.5333 24.808 16.68C24.6947 16.82 24.5547 16.89 24.388 16.89C24.288 16.89 24.198 16.8767 24.118 16.85C24.038 16.8167 23.9447 16.7667 23.838 16.7C23.6047 16.56 23.3847 16.46 23.178 16.4C22.9713 16.34 22.758 16.31 22.538 16.31C21.9447 16.31 21.5013 16.49 21.208 16.85C20.9213 17.2033 20.778 17.7433 20.778 18.47C20.778 19.2033 20.9213 19.75 21.208 20.11C21.5013 20.4633 21.9447 20.64 22.538 20.64C22.738 20.64 22.9313 20.61 23.118 20.55C23.3047 20.4833 23.5447 20.3833 23.838 20.25C23.978 20.1767 24.0813 20.1267 24.148 20.1C24.2147 20.0733 24.2947 20.06 24.388 20.06C24.5547 20.06 24.6947 20.1333 24.808 20.28C24.928 20.42 24.988 20.5933 24.988 20.8C24.988 20.94 24.9613 21.06 24.908 21.16C24.8613 21.2533 24.7813 21.34 24.668 21.42C24.028 21.8667 23.2847 22.09 22.438 22.09Z" fill="white"/><path d="M27.9691 7.85454H21.8839C20.9202 7.85454 20.1381 7.07244 20.1381 6.1087V0.015625L27.9691 7.85454Z" fill="#1E7AC8"/></svg>'
                        }
                    })
                    .on('fileremoved', function (event, id, index) {
                        var filesCount = $('#files-chat').fileinput('getFilesCount', true)

                        that.files = $('#files-chat').fileinput('getFileList')

                        if (filesCount === 0 && that.message === '') {
                            $('.sc-user-input--send-icon-wrapper').addClass('disabled')
                        }

                        that.changeListHeight()

                        that.filesSizeLimit(that.files)
                    })
                    .on('filebatchselected', function (event) {
                        that.files = $('#files-chat').fileinput('getFileList')
                        that.changeListHeight()

                        that.filesSizeLimit(that.files)
                    })
            },
            uploadFile() {
                const fileInput = $('#files-chat')

                if ($(this.$el).find('.file-input').length === 0) {
                    this.createFileInput(fileInput)
                }

                fileInput.click()
            },
            changeListHeight() {
                const appHeight = $(window).height()
                const inputHeight = $('.sc-user-input')[0].offsetHeight
                const chatHeaderHeight = 0
                if($('.sc-header').length > 0) {
                chatHeaderHeight = $('.sc-header')[0].offsetHeight
                }
                const headerHeight = parseInt($('.page-container').css('padding-top'))
                var matrixPanelHeight = 0
                var navTabsHeight = 0
                const messageList = $('.sc-message-list')
                const messageListOuterHeight = messageList.outerHeight()

                if($('.sc-header').length > 0) {
                    chatHeaderHeight = $('.sc-header')[0].offsetHeight
                }

                if (this.user.role === 'coach') {
                    matrixPanelHeight = $('.matrix-panel')[0].offsetHeight
                    navTabsHeight = $('.nav-tabs')[0].offsetHeight
                }

                messageList.outerHeight(
                    appHeight - inputHeight - chatHeaderHeight - headerHeight - matrixPanelHeight - navTabsHeight
                )

                if(messageListOuterHeight !== messageList.outerHeight()) {
                    messageList.animate({ scrollTop: messageList[0].scrollHeight }, 0)
                }
            },
            totalFilesSize(files) {
                var totalSize = 0
                var i = 0

                while (i < files.length) {
                    totalSize += files[i].size
                    i++
                }

                return totalSize
            },
            filesSizeLimit(files) {
                const limit = 10000000
                const size = this.totalFilesSize(files)

                if (size > limit) {
                    $('.kv-fileinput-error').show()
                    $('.file-button .sc-user-input--picker-wrapper').addClass('disabled')
                    if ($('.kv-fileinput-error ul li').length === 0) {
                        $('.kv-fileinput-error').html(
                            '<div><ul><li class="error-files-size">Celková velikost souborů je příliš velká,  maximální povolená velikost je <b>10 MB</b>.</li></ul></div>'
                        )
                    } else if (!$('.kv-fileinput-error ul li').hasClass('error-files-size')) {
                        $('.kv-fileinput-error ul').append(
                            '<li class="error-files-size">Celková velikost souborů je příliš velká,  maximální povolená velikost je <b>10 MB</b>.</li>'
                        )
                    }
                } else {
                    $('.error-files-size').remove()
                    $('.file-button .sc-user-input--picker-wrapper').removeClass('disabled')
                    if ($('.kv-fileinput-error ul li').length === 0) {
                        $('.kv-fileinput-error').hide()
                    }
                }
            }
        }
    }
</script>